<hrt-tab
    [hasTabs]="true"
    [title]="'Feedback'"
    [tabs]="feedbackTabs"
    [renderAllTabs]="false"
    [selectedIndex]="selectedTabIndex"
  ></hrt-tab>

